import Group from "@/types/usergroup";

export default function isGroupInList(
  groups: Group[],
  groupName: string
): boolean {
  return groups.some((group) => group.name.toLowerCase() === groupName);
}
